import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, NavigationEnd } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'primeng/tooltip';
import { CommonService } from '../../core/common/common.service';
import { getNavigationItemsForRoles, NavItem } from '../../core/navigation/navigation.config';
import { RoleService } from '../../core/others/role/role.service';
import { Auth0WrapperService } from '@auth/bp-pf-auth';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmissionStartChoiceComponent } from '../../../shared/submission-start-choice/submission-start-choice.component';
import { ProfileSettingsComponent } from '../../../shared/profile-settings/profile-settings.component';
import { UserRole } from '../../core/data/model/user-role.model';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, TooltipModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  visibleItems: NavItem[] = [];

  commonService = inject(CommonService);

  userEmail = '';
  profileInitial = '';
  userName = '';
  userRole: UserRole | '' = '';
  expandedItem: string | null = null;

  hoveredItem: string | null = null;
  flyoutTop = 0;
  flyoutLeft = 0;
  private closeTimeout: any;

  @Input() isOpen = true;
  @Input() navItems: NavItem[] = [];
  @Output() sidebarToggle = new EventEmitter<boolean>();
  contactEmail = 'info@greenshieldrisk.com';

  constructor(
    private roleService: RoleService,
    private auth: Auth0WrapperService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.roleService.roles$.subscribe(roles => {
      this.visibleItems = getNavigationItemsForRoles(roles);
      if (roles?.length) {
        this.userRole = roles[0];
      }
         this.restoreExpandedFromUrl();
    });
    this.userRole = this.roleService.role;
    this.loadUser();
  }

  loadUser() {
    const email = this.commonService.getEmail();
    if (email) {
      this.userEmail = email;

      const localPart = email.split('@')[0];
      const parts = localPart.split('.');

      this.userName = parts
        .map(p => p.charAt(0).toUpperCase() + p.slice(1))
        .join(' ');

      this.profileInitial = parts
        .map(p => p.charAt(0).toUpperCase())
        .join('');
    }
  }

  private restoreExpandedFromUrl(): void {
    const currentUrl = this.commonService.router.url;
    const activeParent = this.visibleItems.find(item =>
      item.children?.some(child => currentUrl.split('?')[0].includes(`/${child.route}`))
    );
    this.expandedItem = activeParent ? activeParent.label : null;
  }

  private formatRole(role: string): string {
    return role
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  toggleSidebar(): void {
    this.isOpen = !this.isOpen;
    this.sidebarToggle.emit(this.isOpen);
    if (this.isOpen) {
      this.restoreExpandedFromUrl();
    }
  }

  navigate(path: string): void {
   
    this.hoveredItem = null;
    this.commonService.navigateToURLWithtenantCode(path);
  }

  onItemHover(item: NavItem, event: MouseEvent): void {
    if (!this.isOpen && item.children?.length) {
      clearTimeout(this.closeTimeout);
      this.hoveredItem = item.label;
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.flyoutTop = rect.top;
      this.flyoutLeft = rect.right + 6;
    }
  }

  onItemLeave(): void {
    this.closeTimeout = setTimeout(() => {
      this.hoveredItem = null;
    }, 200);
  }

  onFlyoutEnter(): void {
    clearTimeout(this.closeTimeout);
  }

  onFlyoutLeave(): void {
    this.onItemLeave();
  }

  goToSettings() {
    const modalRef = this.modalService.open(ProfileSettingsComponent, {
      centered: true,
      backdrop: 'static',
      size: 'md',
       keyboard: false,
    });

    modalRef.componentInstance.email = this.userEmail;
    modalRef.componentInstance.fullName = this.userName;
    modalRef.componentInstance.role = this.formatRole(this.userRole);
  }

  logout() {
    this.auth.logoutWithRedirect();
  }

  onNavClick(item: NavItem): void {
    if (item.children?.length) {
      this.toggleExpand(item);
    } else if (item.openPopup) {
      this.openCreateSubmissionPopup();
    } else {
      this.navigate(item.route);
    }
  }

  openCreateSubmissionPopup(): void {
    const modalRef = this.modalService.open(SubmissionStartChoiceComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
       keyboard: false,
    });
  }

  toggleExpand(item: NavItem): void {
   
    this.expandedItem = this.expandedItem === item.label ? null : item.label;
  }

  isChildActive(item: NavItem): boolean {
    if (!item.children?.length) return false;
    if (this.isOpen) return false;
    return item.children.some(child =>
      this.commonService.router.url.includes(child.route)
    );
  }
}